export default "__VITE_ASSET__1325e52f__"